import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type IconButtonTone = 'default' | 'accent';

export interface IconButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'className' | 'children'
> {
  /** Required. A glyph-only control with no accessible name is unusable. */
  label: string;
  icon: ReactNode;
  active?: boolean;
  danger?: boolean;
  /**
   * 'accent' is the filled 44px button that sits beside a field — the primary action of
   * its row. `active` is a different thing: it means the view this button opens is the
   * one currently shown.
   */
  tone?: IconButtonTone;
}

export function IconButton({
  label,
  icon,
  active,
  danger,
  tone = 'default',
  type = 'button',
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      title={label}
      className={[
        'iconBtn',
        tone === 'accent' ? 'iconBtnAccent' : null,
        active ? 'iconBtnActive' : null,
        danger ? 'iconBtnDanger' : null,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {icon}
    </button>
  );
}
